import Loadable from 'react-loadable';
import React from 'react';

const emptyState = () => <div/>;

export const MobileDeviceContainer = Loadable({
    loader: () => import('../mobile-device'),
    loading: emptyState
});

export const ShareContainer = Loadable({
    loader: () => import('../share/index'),
    loading: emptyState
});

export const TermsOfUseContainer = Loadable({
    loader: () => import('../policy/termsOfUse'),
    loading: emptyState
});

export const PrivacyPolicy = Loadable({
    loader: () => import('../policy/privacyPolicy'),
    loading: emptyState
});

export const ResetPasswordContainer = Loadable({
    loader: () => import('../registration/resetPassword/ResetPasswordContainer'),
    loading: emptyState
});

export const SignUpConfirmContainer = Loadable({
    loader: () => import('../registration/signUp/SignUpConfirmContainer'),
    loading: emptyState
});

export const RegistrationContainer = Loadable({
    loader: () => import('../registration'),
    loading: emptyState
});

export const SigninPage = Loadable({
    loader: () => import('../signin/SigninPage'),
    loading: emptyState,
});

export const SetInitialPasswordPage = Loadable({
    loader: () => import('../signin/SetInitialPasswordPage'),
    loading: emptyState,
});

export const RequestDemoPage2 = Loadable({
    loader: () => import('../signup/RequestDemoPage'),
    loading: emptyState,
});

export const RequestDemoSuccess = Loadable({
    loader: () => import('../signup/RequestDemoSuccess'),
    loading: emptyState,
});

export const SignupRolePage = Loadable({
    loader: () => import('../signup/SignupRolePage'),
    loading: emptyState,
});

export const SignupRolePageTeacher = Loadable({
    loader: () => import('../signup/SignupRolePage/SignupRolePageTeacher'),
    loading: emptyState,
});

export const SignupRolePageStudent = Loadable({
    loader: () => import('../signup/SignupRolePage/SignupRolePageStudent'),
    loading: emptyState,
});

export const SignupSelectPage = Loadable({
    loader: () => import('../signup/SignupSelectPage'),
    loading: emptyState,
});

export const ManagePage = Loadable({
    loader: () => import('../main/students/manage/ManagePage'),
    loading: emptyState,
});

export const SchoolTeachersPage = Loadable({
    loader: () => import('../main/schools/teachers/SchoolTeacherContainer'),
    loading: emptyState,
});

export const SchoolStudentsPage = Loadable({
    loader: () => import('../main/schools/students/SchoolStudentContainer'),
    loading: emptyState,
});

export const MeetingsContainer = Loadable({
    loader: () => import('../main/meetings'),
    loading: emptyState,
});

export const ChangePasswordContainer = Loadable({
    loader: () => import('../registration/changePassword/ChangePassword'),
    loading: emptyState,
});

export const SupportPage = Loadable({
    loader: () => import('../main/support'),
    loading: emptyState,
});

export const ProfilePage = Loadable({
    loader: () => import('../main/profile/Profile'),
    loading: emptyState,
});

export const PricingPage = Loadable({
    loader: () => import('../main/payment/PaymentContainer'),
    loading: emptyState,
});

export const PaymentPage = Loadable({
    loader: () => import('../main/payment/PaymentContainer'),
    loading: emptyState,
});

export const MainContainer = Loadable({
    loader: () => import('../main'),
    loading: emptyState,
});

export const StudioPage = Loadable({
    loader: () => import('../studio/StudioPage'),
    loading: emptyState,
});

export const StudioMainContainer = Loadable({
    loader: () => import('../studio/main/StudioMainContainer'),
    loading: emptyState,
});

export const StudioWizardContainer = Loadable({
    loader: () => import('../studio/wizard/StudioWizardContainer'),
    loading: emptyState,
});

export const CreateModeContainer = Loadable({
    loader: () => import('../create/CreateModeContainer'),
    loading: emptyState,
});

export const HomeContainer = Loadable({
    loader: () => import('../main/home/HomeContainer'),
    loading: emptyState,
});

export const TeacherHomeContainer = Loadable({
    loader: () => import('../main/home/teacherHome/TeacherHomeContainer'),
    loading: emptyState,
});

export const StudentTimeline = Loadable({
    loader: () => import('../main/assignments/AssignmentsContainer'),
    loading: emptyState,
});

export const GroupTimeline = Loadable({
    loader: () => import('../main/assignments/AssignmentsContainer'),
    loading: emptyState,
});

export const SelectStudentContainer = Loadable({
    loader: () => import('../main/select-student/SelectStudentContainer'),
    loading: emptyState,
});

export const SchoolsContainer = Loadable({
    loader: () => import('../main/schools/SchoolsContainer'),
    loading: emptyState,
});

export const SchoolContainer = Loadable({
    loader: () => import('../main/schools/SchoolContainer'),
    loading: emptyState,
});

export const DiscoverLessonsContainer = Loadable({
    loader: () => import('../main/discover/DiscoverLessonsContainer'),
    loading: emptyState,
});

export const DiscoverLessonsWrapper = Loadable({
    loader: () => import('../main/discover/DiscoverLessonWrapper'),
    loading: emptyState,
});

export const LessonPlanLibrary = Loadable({
    loader: () => import('../main/lessons-library/LessonsLibrary'),
    loading: emptyState,
});

export const LessonPage = Loadable({
    loader: () => import('../main/lesson-page/LessonPage'),
    loading: emptyState,
});

export const PracticeLibrary = Loadable({
    loader: () => import('../main/practice/PracticeLibrary'),
    loading: emptyState,
});

export const JamsLibrary = Loadable({
    loader: () => import('../main/jams/JamsLibrary'),
    loading: emptyState,
});

export const GroupPage = Loadable({
    loader: () => import('../main/groups/GroupContainer'),
    loading: emptyState,
});

export const SocialLogin = Loadable({
    loader: () => import('../signin/SocialLogin'),
    loading: emptyState,
});

export const AdminStudentsContainer = Loadable({
    loader: () => import('../main/admin/AdminStudentsContainer'),
    loading: emptyState,
});

export const AdminLessonsContainer = Loadable({
    loader: () => import('../main/admin/AdminLessonsContainer'),
    loading: emptyState,
});

export const AdminPayproContainer = Loadable({
    loader: () => import('../main/admin/AdminPayproContainer'),
    loading: emptyState,
});

export const AdminHomeContainer = Loadable({
    loader: () => import('../main/admin/AdminHomeContainer'),
    loading: emptyState,
});
